export default __webpack_public_path__ + "static/media/1784.fe4dbd82.png";